module.exports = __webpack_public_path__ + "assets/default_participant_picture_300x300.jpg";